import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 首页
export const appHomePage = (): any => http.httpGet({
    url: httpApi.homeIndex.appHomePage
})

// 获取区服列表
interface DistrictListJson {
    box_game_id: string
}
export const districtList = (json: DistrictListJson): any => http.httpGet({
    url: httpApi.homeIndex.districtList,
    json
})

// 获取角色列表
interface RoleListJson {
    server_id: string
}
export const roleList = (json: RoleListJson): any => http.httpGet({
    url: httpApi.homeIndex.roleList,
    json
})

// 获取商品筛选项
export const commodityConfig = (json: DistrictListJson): any => http.httpGet({
    url: httpApi.homeIndex.commodityConfig,
    json
})

// 商品列表
interface CommodityListJson {
    size: number,
    page: number,
    box_game_id: string,
    server_id: string,
    role_config_id: string,
    coin_config_id: string,
    order_time: string,
    order_price: string,
}
export const commodityList = (json: CommodityListJson): any => http.httpGet({
    url: httpApi.homeIndex.commodityList,
    json
})

// 商品详情
interface CommodityDetailJson {
    commodity_id: string
}
export const commodityDetail = (json: CommodityDetailJson): any => http.httpGet({
    url: httpApi.homeIndex.commodityDetail,
    json
})

// 商品收藏
export const commodityCollect = (json: CommodityDetailJson): any => http.httpPost({
    url: httpApi.homeIndex.commodityCollect,
    json
})

// 取消收藏
export const commodityCancelCollect = (json: CommodityDetailJson): any => http.httpPost({
    url: httpApi.homeIndex.commodityCancelCollect,
    json
})
